import React from "react"
import { UserBadge } from "components-design-system"

const containerStyle = { display: "flex", gap: 4, flexWrap: "wrap" }

const UserFullnameCellRenderer = React.memo(({ value, size = "sm", showFullName }) => {
  if (!value) {
    return null
  }

  if (Array.isArray(value)) {
    return (
      <div style={containerStyle}>
        {value.map((user, i) => (
          <UserBadge
            key={`${user}-${i}`}
            user={user}
            size={size}
            showFullName={showFullName}
          />
        ))}
      </div>
    )
  }

  return (
    <UserBadge
      user={value}
      size={size}
      showFullName={showFullName}
    />
  )
})

export default UserFullnameCellRenderer
